import GOOGLEMAP from '../plugins/googlemap'
import CONTENT_HEADER from '../plugins/content_header'

const [w,d,host] = [window,document,location.host]

export default function COMPANY() {

  // Googlemap実行パート
  
  const km = w.siteinfo.mapApiKeys
  const env_map_key = (!km[host]) ? km['local'] : km[host]
  w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})

  // map
  d.addEventListener( 'DOMContentLoaded', () => {
    w.load['mapScript'].done( () => GOOGLEMAP( {
        markers:[
          {
            title:'Ds 本社',
            address: '浜松市東区北島町879',
            icon:'/src/lib_images/map_peg01.png'
          },
          {
            title:'Ds 和田工場',
            address: '浜松市東区和田町344-2',
            icon:'/src/lib_images/map_peg02.png'
          }
        ],
        centerAdjust:{
          lat:-0.005,
          lng:-0.005
        }
      } )
    )
  } );

}